import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/siren.vue
var s = {
	name: "DtIconSiren",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["clip-path"], u = ["id"];
function d(e, t, n, s, d, f) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([f.iconSizeClass, "d-icon d-icon--siren"]),
		"data-qa": f.dataQA,
		"aria-hidden": f.ariaHidden,
		role: "img",
		"data-name": "Siren",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [i("g", { "clip-path": `url(#${e.uniqueID}a)` }, [...t[0] || (t[0] = [i("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M6 .5a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-1 0V1A.5.5 0 0 1 6 .5Zm3.604 1.396a.5.5 0 0 1 0 .708l-.25.25a.5.5 0 1 1-.708-.708l.25-.25a.5.5 0 0 1 .708 0Zm-7.493.215a.5.5 0 0 1 .707 0l.354.353a.5.5 0 0 1-.708.708l-.353-.354a.5.5 0 0 1 0-.707ZM6 4a2 2 0 0 0-2 2v2.5h1.5V6a.5.5 0 0 1 1 0v2.5H8V6a2 2 0 0 0-2-2Zm3 4.586V6a3 3 0 1 0-6 0v2.586A1.5 1.5 0 0 0 2 10v1a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-1a1.5 1.5 0 0 0-1-1.414ZM3.5 9.5a.5.5 0 0 0-.5.5v.5h6V10a.5.5 0 0 0-.5-.5h-5ZM.5 6a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 0 1H1A.5.5 0 0 1 .5 6ZM10 6a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 0 1h-.5A.5.5 0 0 1 10 6Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 8, l), i("defs", null, [i("clipPath", { id: `${e.uniqueID}a` }, [...t[1] || (t[1] = [i("path", {
		fill: "#fff",
		d: "M0 0h12v12H0z"
	}, null, -1)])], 8, u)])], 10, c);
}
var f = /* @__PURE__ */ n(s, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=siren.js.map